#import "../fragments/ai-feature-enabled-fragment.graphql"

query GetAiFeatureEnabled($type: AiFeatureType!) {
    aiFeatureUsage(type: $type) {
        ...AiFeatureEnabledFragment
    }
}
